/**
 * @description 路由守卫，目前两种模式：all模式与intelligence模式
 */
import { useUserStore } from "@/store/modules/user";
import { useRoutesStore } from "@/store/modules/routes";
import { useSettingsStore } from "@/store/modules/settings";
import VabProgress from "nprogress";
import "nprogress/nprogress.css";
import getPageTitle from "@/utils/pageTitle";
import { toLoginRoute } from "@/utils/routes";
import { authentication, loginInterception, routesWhiteList, } from "@/config";
function findParentByCode(cityList, dataCode) {
    function isTarget(item) {
        return item && typeof item === 'object' && item.code === dataCode;
    }
    function search(items, parent = null) {
        if (Array.isArray(items)) {
            for (const item of items) {
                const result = search(item, parent);
                if (result)
                    return result;
            }
        }
        else if (items && typeof items === "object") {
            // 检查直接子节点
            if (items.children) {
                if (items.children.some(isTarget)) {
                    return items;
                }
                // 递归搜索子节点
                for (const child of items.children) {
                    const result = search(child, items);
                    if (result)
                        return result;
                }
            }
            // 检查town节点
            if (items.town) {
                if (items.town.some(isTarget)) {
                    return items;
                }
                // 递归搜索town节点
                for (const town of items.town) {
                    const result = search(town, items);
                    if (result)
                        return result;
                }
            }
        }
        return null;
    }
    return search(cityList);
}
export function setupPermissions(router) {
    VabProgress.configure({
        easing: "ease",
        speed: 500,
        trickleSpeed: 200,
        showSpinner: false,
    });
    router.beforeEach(async (to, from, next) => {
        if ((to.path == "/visualization/childustody" && from.path == '/visualization/industrySupervision') || (to.path == "/visualization/childustody" && from.path == '/visualization/revenueTax') || (to.path == "/visualization/governmentServicesUpdates" && from.path == '/visualization/revenueTax') || (to.path == "/visualization/governmentServicesUpdates" && from.path == '/visualization/industrySupervision')) {
            const { cityList, vipInfos, cityInfo } = useUserStore();
            // 当权限在乡镇或者街道时 跳转回实时游客看板时需要调整当前权限到区县
            if (cityInfo.value.length == 12) {
                const matchedCity = findParentByCode(cityList, cityInfo.value);
                cityInfo.label = matchedCity.label;
                cityInfo.value = matchedCity.value;
                cityInfo.id = 1;
                cityInfo.town = '';
            }
        }
        const { getTheme: { showProgressBar }, } = useSettingsStore();
        const { routes, setRoutes } = useRoutesStore();
        const { token, resetAll } = useUserStore();
        if (showProgressBar)
            VabProgress.start();
        let hasToken = token;
        // 是否开启登录拦截
        if (!loginInterception)
            hasToken = true;
        if (hasToken) {
            if (routes.length) {
                // 禁止已登录用户返回登录页和未登录的首页
                if (to.path === "/login") {
                    next({ path: "/userindex" });
                    if (showProgressBar)
                        VabProgress.done();
                }
                else
                    next();
            }
            else {
                try {
                    // if (loginInterception) await getUserInfo();
                    // config/setting.config.js loginInterception为false(关闭登录拦截时)时，创建虚拟角色
                    // else await setVirtualRoles()
                    // 根据路由模式获取路由并根据权限过滤
                    await setRoutes(authentication);
                    next({ ...to, replace: true });
                }
                catch (err) {
                    console.error("vue-admin-beautiful错误拦截:", err);
                    await resetAll();
                    next(toLoginRoute(to.path));
                }
            }
        }
        else {
            if (routesWhiteList.includes(to.path)) {
                // 设置游客路由(不需要可以删除)
                // if (supportVisit && !routes.length) {
                //   await setRoutes('visit')
                //   next({ path: to.path, replace: true })
                // } else
                next();
            }
            else
                next(toLoginRoute(to.path));
        }
    });
    router.afterEach((to) => {
        document.title = getPageTitle(to.meta.title);
        if (VabProgress.status)
            VabProgress.done();
    });
}
